<h3 id="heading" style="margin-left: 10px; display: none;">Select Fan<span class="close-btn" (click)="closePopup()" style="float: right;
    margin: 10px;
    font-size: 20px;
    font-weight: normal;
    cursor: pointer;
    ">X</span></h3>
    <!-- SE -->
<div id="SE" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F1.png'" (click)="selectImage('Fan on input shaft')" />
                <div class="card-body">
                  <p (click)="selectImage('Fan on input shaft')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan on input shaft<br>
                    </p>
                </div>
            </div>
            
        </div>
        <br><br>
    </div>
</div>

    <!-- DE -->
    <div id="DE" class="container" style="display: none;">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row">
            
                <div style="width: 11rem;">
                    <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F1.png'" (click)="selectImage('Fan on input shaft')" />
                    <div class="card-body">
                      <p (click)="selectImage('Fan on input shaft')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan on input shaft<br>
                        </p>
                    </div>
                </div>
                <div style="width: 11rem;">
                    <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F2.png'" (click)="selectImage('Fan opposite input on double extended shaft')" />
                    <div class="card-body">
                      <p (click)="selectImage('Fan opposite input on double extended shaft')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan opposite input on double extended shaft<br>
                        </p>
                    </div>
                </div>
                <div style="width: 11rem;">
                    <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F3.png'" (click)="selectImage('Fan opposite input, no extension')" />
                    <div class="card-body">
                      <p (click)="selectImage('Fan opposite input, no extension')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan opposite input, no extension<br>
                        </p>
                    </div>
                </div>
                
            </div>
    <br>

        <br>
    </div>
</div>



<!-- SA -->
<div id="SA" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F2.png'" (click)="selectImage('Fan opposite input on double extended shaft')" />
                <div class="card-body">
                  <p (click)="selectImage('Fan opposite input on double extended shaft')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan opposite input on double extended shaft<br>
                    </p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F3.png'" (click)="selectImage('Fan opposite input, no extension')" />
                <div class="card-body">
                  <p (click)="selectImage('Fan opposite input, no extension')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan opposite input, no extension<br>
                    </p>
                </div>
            </div>
            
        </div>
<br>

    <br>
</div>
</div>




<!-- DA -->
<div id="DA" class="container" style="display: none;">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
        
            
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F2.png'" (click)="selectImage('Fan opposite input on double extended shaft')" />
                <div class="card-body">
                  <p (click)="selectImage('Fan opposite input on double extended shaft')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan opposite input on double extended shaft<br>
                    </p>
                </div>
            </div>
            <div style="width: 11rem;">
                <img class="img-thumbnail" [src]=" AssetbasePath + '/Content/HPImages/Fan/F3.png'" (click)="selectImage('Fan opposite input, no extension')" />
                <div class="card-body">
                  <p (click)="selectImage('Fan opposite input, no extension')" class="card-text" style="font-size: 11px;font-weight: bold;">Fan opposite input, no extension<br>
                    </p>
                </div>
            </div>
            
        </div>
<br>

    <br>
</div>
</div>